export default __webpack_public_path__ + "static/salehIbrahim@2x-5778c4bd1286059b78da49e0f2934899.jpg";